// Finnish UI texts. Add a language by copying this file and registering it in i18n/index.ts.
export const fi = {
  app: {
    name: 'HimaPokeri',
    skip: 'Siirry sisältöön',
    loading: 'Ladataan…',
    retry: 'Yritä uudelleen',
    offline: 'Yhteys katkesi. Tiedot päivittyvät, kun yhteys palaa.',
    reconnected: 'Yhteys palasi. Tiedot päivitetty.',
    maintenance: 'Päivitetään. Pelit ja vuorokellot ovat tauolla.',
    close: 'Sulje',
    notFoundTitle: 'Sivua ei löytynyt',
    notFoundBody: 'Sivua ei ole tai et pääse sille.',
    toHome: 'Etusivulle',
    cancel: 'Peruuta',
    save: 'Tallenna',
    saved: 'Tallennettu',
    back: 'Takaisin',
    confirm: 'Vahvista',
    yes: 'Kyllä',
    no: 'Ei',
    more: 'Näytä lisää',
    none: 'Ei mitään',
    required: 'Pakollinen',
  },
  nav: {
    countTurns: '{n} {n|vuoro odottaa|vuoroa odottaa}',
    countUnread: '{n} {n|lukematon|lukematonta}',
    countNotifications: '{n} {n|lukematon ilmoitus|lukematonta ilmoitusta}',
    home: 'Koti',
    tournaments: 'Turnaukset',
    debts: 'Velat',
    chat: 'Keskustelu',
    notifications: 'Ilmoitukset',
    stats: 'Tilastot',
    profile: 'Profiili',
    admin: 'Ylläpito',
    logout: 'Kirjaudu ulos',
    main: 'Päävalikko',
  },
  auth: {
    loginTitle: 'Kirjaudu sisään',
    email: 'Sähköposti',
    sendLink: 'Lähetä kirjautumislinkki',
    linkSentTitle: 'Tarkista sähköposti',
    linkSent: 'Jos osoitteella {email} on tili, lähetimme sinne linkin.',
    linkSentHelp: 'Avaa linkki tällä laitteella. Se toimii kerran, 15 minuutin ajan.',
    linkAgain: 'Lähetä uusi linkki',
    devLinkNote: 'Kehitystila: linkki näkyy myös tässä.',
    devLinkOpen: 'Avaa linkki',
    signingIn: 'Kirjaudutaan…',
    linkFailedTitle: 'Linkki ei enää toimi',
    linkFailed: 'Kirjautumislinkki toimii kerran ja 15 minuutin ajan. Pyydä uusi linkki.',
    newLink: 'Pyydä uusi linkki',
    privateNote: 'Kaveriporukan pokeri. Mukaan pääsee kutsulla.',
    mfaTitle: 'Kaksivaiheinen tunnistautuminen',
    mfaHelp: 'Anna tunnistussovelluksen 6-numeroinen koodi tai palautuskoodi.',
    mfaCode: 'Koodi',
    verify: 'Vahvista',
    mfaSetupTitle: 'Ota kaksivaiheinen tunnistautuminen käyttöön',
    mfaSetupHelp:
      'Ylläpitäjä tarvitsee kirjautumiseen myös koodin. Lue QR-koodi tunnistussovelluksella (esim. Google Authenticator, 1Password tai Aegis) tai lisää avain käsin.',
    mfaSecret: 'Avain',
    mfaEnable: 'Ota käyttöön',
    recoveryTitle: 'Palautuskoodit',
    recoveryHelp: 'Säilytä koodit turvallisessa paikassa. Niillä pääset sisään ilman puhelinta. Kukin toimii kerran, eikä koodeja näytetä uudelleen.',
    recoveryDone: 'Koodit tallessa',
    inviteTitle: 'Tervetuloa, {name}',
    inviteFailedHelp: 'Kutsu toimii kerran. Jos olet jo käyttänyt sen, kirjaudu sähköpostilla.',
    backToLogin: 'Kirjaudu sähköpostilla',
  },
  home: {
    drawing: 'Alkamassa',
    title: 'Koti',
    yourTurn: 'Sinun vuorosi',
    yourTurns: 'Omat vuorot',
    noTurns: 'Saat ilmoituksen, kun on sinun vuorosi.',
    active: 'Omat pelit',
    noActive: 'Ei pelejä kesken.',
    open: 'Ilmoittautuminen auki',
    noOpen: 'Ei avoimia turnauksia.',
    debts: 'Velat',
    iOwe: 'Olet velkaa',
    owedToMe: 'Sinulle ollaan velkaa',
    openDebts: '{n} avointa',
    hand: 'Jako {n}',
    newHands: '{n} uutta jakoa edellisen käyntisi jälkeen',
    playersLeft: '{n} {n|pelaaja|pelaajaa} jäljellä',
    stack: 'Pino',
    level: 'Blindit {sb}/{bb}',
    openTable: 'Avaa pöytä',
    act: 'Pelaa vuoro',
    paused: 'Tauolla',
    recent: 'Viime tulokset',
    noRecent: 'Ei vielä tuloksia.',
    morning: 'Huomenta',
    day: 'Päivää',
    evening: 'Iltaa',
    night: 'Iltaa',
    deadlineShort: 'Aikaa {time} asti',
    outPlace: 'Pudonnut, sijoitus {place}',
    chips: 'merkkiä',
    rank: 'Pino {rank}./{of}',
    rankHelp: 'Sijoitus pinon koon mukaan, mukana olevista pelaajista',
    shareLabel: 'Osuutesi pelimerkeistä {pct} %',
    leader: 'Suurin pino',
    players: 'Pelaajia',
    blinds: 'Blindit',
    handsPlayed: 'Jakoja',
    waitingOn: 'Odotetaan: {name}',
    newHandsShort: '{n} uutta jakoa',
    turnsWaiting: '{n} {n|vuoro odottaa|vuoroa odottaa}.',
    allDone: 'Muiden vuoro.',
    quiet: 'Ei pelejä kesken.',
    allTimeNet: 'Kokonaistulos',
    allTimeSub: '{n} {n|turnaus|turnausta}, {wins} {wins|voitto|voittoa}',
    debtBalance: 'Velkasaldo',
    debtSub: 'Olet velkaa {owe}, sinulle {owed}',
    noTurnsTitle: 'Ei omaa vuoroa',
    allTournaments: 'Kaikki turnaukset',
    youreIn: 'olet mukana',
    pool: 'Palkintopotti {amount}',
  },
  theme: {
    title: 'Teema',
    change: 'Vaihda',
    changeLabel: 'Vaihda teema',
    dialogTitle: 'Valitse teema',
    changed: 'Teema vaihdettu: {name}',
    modeLabel: 'Vaalea vai tumma',
    modeSystem: 'Laitteen mukaan',
    modeLight: 'Vaalea',
    modeDark: 'Tumma',
  },
  invites: {
    title: 'Kutsutut',
    invite: 'Kutsu pelaajia',
    none: 'Ketään ei ole vielä kutsuttu.',
    by: 'kutsui {name}',
    everyoneInvited: 'Kaikki pelaajat on jo kutsuttu tai mukana.',
    dialogTitle: 'Kutsu pelaajia',
    dialogHelp: 'Kutsutut saavat ilmoituksen. Samaa pelaajaa ei voi kutsua kahdesti, eikä jo kutsuttuja näytetä.',
    all: 'Kaikki ({n})',
    send: 'Lähetä {n} {n|kutsu|kutsua}',
    sent: '{n} {n|kutsu|kutsua} lähetetty.',
  },
  organizer: {
    title: 'Järjestäjänä',
    draftTitle: 'Luonnos',
    draftHelp: 'Luonnos näkyy vain sinulle. Julkaise, niin muut voivat liittyä.',
    registrationHelp: 'Voit muuttaa turnausta, kunnes se alkaa. Jos rahaan tai sääntöihin tulee muutos, ilmoittautuneet hyväksyvät sen uudelleen.',
    deleteConfirm: 'Poistetaanko luonnos? Tätä ei voi perua.',
    cancelHelp: 'Turnaus perutaan ennen alkua. Ilmoittautuneet saavat tiedon perustelun kanssa, eikä velkoja synny.',
    published: 'Turnaus julkaistu.',
    deleted: 'Luonnos poistettu.',
    cancelled: 'Turnaus peruttu.',
  },
  tournament: {
    list: 'Turnaukset',
    empty: 'Ei vielä turnauksia. Ylläpitäjä voi luoda pelin.',
    filters: {
      mine: 'Omat',
      open: 'Avoimet',
      running: 'Käynnissä',
      finished: 'Päättyneet',
      all: 'Kaikki',
      none: 'Ei turnauksia tällä valinnalla.',
    },
    columns: { name: 'Turnaus', status: 'Tila', me: 'Minä', seats: 'Paikat', buyIn: 'Maksu' },
    status: {
      draft: 'Luonnos',
      registration: 'Ilmoittautuminen',
      running: 'Käynnissä',
      paused: 'Tauolla',
      finished: 'Päättynyt',
      cancelled: 'Peruttu',
    },
    placeText: '{place} sija',
    playerCount: '{n} {n|pelaaja|pelaajaa}',
    joinWithPrice: 'Liity turnaukseen · {price}',
    entryStatus: {
      registered: 'Ilmoittautunut',
      withdrawn: 'Poistunut',
      playing: 'Mukana',
      eliminated: 'Pudonnut',
      winner: 'Voittaja',
      cancelled: 'Peruttu',
    },
    seats: '{registered}/{capacity} paikkaa',
    buyIn: 'Pelimaksu',
    prizePool: 'Palkintopotti',
    capacity: 'Pelaajia',
    startingStack: 'Aloitusmerkit',
    blinds: 'Blinditasot',
    blindsHelp: 'Blindit nousevat {n} jaon välein, aina jakojen välissä.',
    showAllLevels: 'Näytä kaikki {n} tasoa',
    showFewerLevels: 'Näytä vähemmän',
    level: 'Taso',
    sb: 'SB',
    bb: 'BB',
    ante: 'Ante',
    anteMode: { none: 'Ei antea', classic: 'Jokainen maksaa anten', bb_ante: 'BB maksaa anten koko pöydän puolesta' },
    turnTime: 'Vuoroaika',
    reminders: 'Muistutukset',
    remindersValue: '{list} ennen ajan loppumista',
    away: 'Poissa-tila',
    awayValue: 'Kun aika loppuu {n} kertaa peräkkäin',
    payout: 'Voitonjako',
    place: 'Sija',
    share: 'Osuus',
    prize: 'Palkinto',
    rounding: 'Palkinnot pyöristetään alaspäin senttiin. Ylijäävät sentit jaetaan yksi kerrallaan parhaasta sijasta alkaen.',
    chipsNotMoney: 'Pelimerkit eivät ole rahaa. Vain pelimaksut ja palkinnot lasketaan euroina.',
    organizer: 'Järjestäjä: {name}',
    moneyNote: 'Rahat maksetaan keskenään. Peli kirjaa turnauksen lopuksi, kuka on velkaa kenelle.',
    rulesTitle: 'Pelisäännöt',
    timeoutRule: 'Kun aika loppuu, peli checkaa puolestasi. Jos se ei onnistu, peli foldaa. Peli ei koskaan callaa tai korota puolestasi.',
    entrants: 'Osallistujat',
    noEntrants: 'Ei vielä ilmoittautuneita.',
    termsPending: 'Ei vielä hyväksynyt muutoksia',
    join: 'Liity turnaukseen',
    joinConfirm: 'Hyväksyn pelimaksun {buyIn} ja säännöt (versio {version}).',
    joinDialogTitle: 'Mukaan turnaukseen?',
    joinFreeConfirm: 'Hyväksyn säännöt (versio {version}).',
    joinSummary: 'Pelimaksu {buyIn}, palkintopotti {pool}, {capacity} pelaajaa.',
    realMoneyTitle: 'Pelataan oikealla rahalla',
    realMoneyText:
      'Pelimaksu on {buyIn}. Peli kirjaa velat, mutta ei siirrä rahaa. Jos häviät, maksa velkasi voittajille pian turnauksen jälkeen, esimerkiksi MobilePaylla.',
    realMoneyAccept: 'Pelaan oikealla rahalla ja maksan tappioni voittajille (esim. MobilePaylla).',
    joinAndAccept: 'Hyväksy ja liity',
    joinedStarted: 'Pöytä täynnä. Turnaus alkoi.',
    joined: 'Olet mukana. Peli alkaa, kun pöytä on täynnä.',
    withdraw: 'Poistu turnauksesta',
    withdrawConfirm: 'Poistutko turnauksesta? Voit palata, jos tilaa on.',
    termsChanged: 'Turnauksen tiedot muuttuivat',
    termsChangedHelp: 'Paikka on tallessa. Tarkista merkityt muutokset ja hyväksy ne tai poistu, jotta peli voi alkaa.',
    was: 'aiemmin {value}',
    acceptNew: 'Hyväksy muutokset',
    registrationDeadline: 'Ilmoittautuminen päättyy',
    cancelled: 'Turnaus peruttiin: {reason}',
    pausedBanner: 'Tauolla: {reason}. Vuorokello on pysähtynyt.',
    maintenanceBanner: 'Päivitetään. Peli ja vuorokello ovat tauolla. Peli jatkuu itsestään.',
    maintenanceWait: 'Voit pelata vuorosi päivityksen jälkeen.',
    goTable: 'Pöytä',
    results: 'Tulokset',
    history: 'Jakohistoria',
    info: 'Tiedot',
    chat: 'Keskustelu',
  },
  table: {
    title: 'Pöytä',
    pot: 'Potti',
    mainPot: 'Pääpotti',
    sidePot: 'Sivupotti {n}',
    board: 'Pöytäkortit',
    noBoard: 'Ei vielä pöytäkortteja',
    yourHand: 'Oma käsi',
    hidden: 'Piilossa',
    dealer: 'Jakaja',
    sbShort: 'SB',
    bbShort: 'BB',
    folded: 'Foldannut',
    allIn: 'All-in',
    away: 'Poissa',
    out: 'Pudonnut',
    toAct: 'Vuorossa',
    waitingFor: 'Odotetaan: {name}',
    equity: 'Voittomahdollisuus {p}',
    handEnded: 'Jako #{n} päättyi',
    continue: 'Jatka',
    preTitle: 'Ennakkovalinta',
    preCheckFold: 'Check/Fold',
    preFold: 'Fold',
    preCheck: 'Check',
    preCall: 'Call',
    pausedShort: 'tauolla',
    yourTurn: 'Sinun vuorosi',
    deadline: 'Aikaa {time} asti',
    timeLeft: '{time} jäljellä',
    pausedLeft: 'Tauolla, {time} jäljellä',
    fold: 'Fold',
    check: 'Check',
    call: 'Call {amount}',
    callAllIn: 'Call all-in {amount}',
    callShort: 'Call',
    chipsUnit: 'merkkiä',
    unitLabel: 'Summien yksikkö',
    unitChips: 'Merkit',
    unitBb: 'BB',
    callAllInShort: 'Call all-in',
    sizeLabel: 'Panoksen koko suhteessa pottiin',
    decrease: 'Pienennä yhdellä isolla blindillä',
    increase: 'Suurenna yhdellä isolla blindillä',
    bet: 'Bet',
    raise: 'Raise',
    allin: 'All-in',
    betTo: 'Panos tällä kierroksella yhteensä',
    raiseTo: 'Korota yhteensä',
    adds: 'Lisäät {amount}',
    minMax: 'Vähintään {min}, enintään {max}',
    presetMin: 'Min',
    presetHalfPot: '½ potti',
    presetPot: 'Potti',
    presetMax: 'Kaikki',
    confirmAction: 'Vahvista: {action}',
    sending: 'Lähetetään…',
    notYourTurn: 'Odota vuoroasi.',
    staleTurn: 'Tilanne muuttui. Tarkista päivitetty pöytä ja pelaa uudelleen.',
    deadlinePassed: 'Aika loppui. Peli checkasi tai foldasi puolestasi.',
    awayBanner: 'Olet poissa. Peli checkaa tai foldaa vuorosi heti.',
    comeBack: 'Palaa pöytään',
    lastAction: 'Viime siirto',
    previousHand: 'Edellinen jako #{n}',
    wonPot: '{name} voitti {amount}',
    withHand: '({hand})',
    handNo: 'Jako #{n}',
    level: 'Taso {n}: {sb}/{bb}',
    levelAnte: 'Taso {n}: {sb}/{bb}, ante {ante}',
    nextLevel: 'Seuraava taso {sb}/{bb} {n} jaon päästä',
    nextLevelNow: 'Seuraavan jaon blindit: {sb}/{bb}',
    lastLevel: 'Viimeinen blinditaso',
    infoHand: 'Jako',
    infoStreet: 'Katu',
    infoNoHand: 'Ei jakoa käynnissä',
    infoBlinds: 'SB/BB, taso {n}',
    infoAnte: 'ante {ante}',
    infoNext: 'Seuraava taso',
    infoNextIn: '{n} jaon päästä',
    infoNextNow: 'seuraavasta jaosta',
    infoLevelProgress: 'Jaot nykyisellä blinditasolla',
    streets: { preflop: 'Preflop', flop: 'Flop', turn: 'Turn', river: 'River' },
    sinceTitle: 'Edellisen käyntisi jälkeen',
    sinceHands: 'Pelattu {n} jakoa',
    sinceChips: 'Pinon muutos {delta}',
    sinceTimeouts: 'Aikasi loppui {n} kertaa',
    sinceBig: 'Suurin potti: jako #{n}, {amount}',
    sinceOk: 'Selvä',
    finished: 'Turnaus päättyi.',
    showResults: 'Näytä tulokset',
    spectating: 'Katsot peliä.',
    events: 'Tapahtumat',
    stackLabel: 'Pino',
    betLabel: 'Panos',
    chatOpen: 'Keskustelu',
    panelLabel: 'Keskustelu ja tapahtumat',
    resizePanel: 'Muuta paneelin leveyttä vetämällä tai nuolinäppäimillä',
    showChat: 'Näytä keskustelu',
    showPanel: 'Näytä tapahtumat',
    hidePanel: 'Piilota sivupaneeli',
    fullscreen: 'Koko näyttö',
    exitFullscreen: 'Poistu koko näytöstä',
    exitFullscreenHint: 'Myös Esc sulkee',
    chatClose: 'Piilota keskustelu',
  },
  log: {
    potsWon: '{n} pottia',
    ante: '{name} maksaa anten {amount}',
    sb: '{name} maksaa SB:n {amount}',
    bb: '{name} maksaa BB:n {amount}',
    fold: '{name} foldaa',
    check: '{name} checkaa',
    call: '{name} callaa {amount}',
    bet: '{name} panostaa {amount}',
    raise: '{name} korottaa, yhteensä {amount}',
    allin: ' (all-in)',
    autoTimeout: ' – aika loppui',
    autoTimeoutShort: 'aika loppui',
    autoAwayShort: 'poissa',
    autoTimeoutLong: 'Aika loppui. Peli checkasi tai foldasi.',
    autoAwayLong: 'Pelaaja poissa. Peli checkasi tai foldasi.',
    shows: 'näyttää',
    wins: 'voittaa',
    autoAway: ' – poissa',
    return: '{name} saa takaisin {amount} (panos, jota kukaan ei maksanut)',
    street: '{street}: {cards}',
    reveal: '{name} näyttää {cards}',
    muck: '{name} ei näytä korttejaan',
    award: '{name} voittaa {amount}',
    deal: 'Kortit jaetaan',
  },
  hands: {
    straight_flush: 'Värisuora',
    four_of_a_kind: 'Neloset',
    full_house: 'Täyskäsi',
    flush: 'Väri',
    straight: 'Suora',
    three_of_a_kind: 'Kolmoset',
    two_pair: 'Kaksi paria',
    one_pair: 'Pari',
    high_card: 'Hai',
  },
  suits: { s: 'pata', h: 'hertta', d: 'ruutu', c: 'risti' },
  ranks: { A: 'ässä', K: 'kuningas', Q: 'kuningatar', J: 'jätkä', T: 'kymppi' },
  events: {
    published: 'Turnaus julkaistiin',
    joined: '{name} ilmoittautui',
    withdrew: '{name} poistui',
    terms_changed: 'Turnauksen tietoja muutettiin (versio {version})',
    started: 'Turnaus alkoi',
    level_up: 'Blindit nousivat: {sb}/{bb}',
    eliminated: '{name} putosi sijalle {place}',
    away: '{name} on poissa',
    back: '{name} palasi pöytään',
    paused: 'Ylläpitäjä keskeytti turnauksen: {reason}',
    resumed: 'Turnaus jatkuu',
    deadline_extended: 'Katko antoi pelaajalle {name} lisää vuoroaikaa',
    cancelled: 'Turnaus peruttiin: {reason}',
    finished: 'Turnaus päättyi',
    corrected: 'Tulosta korjattiin: {reason}',
  },
  results: {
    title: 'Tulokset',
    place: 'Sija',
    player: 'Pelaaja',
    prize: 'Palkinto',
    net: 'Voitto tai tappio',
    pool: 'Palkintopotti {amount}',
    notFinished: 'Peli on kesken. Tulokset tulevat turnauksen lopuksi.',
    debtsTitle: 'Turnauksen velat',
    yourDebts: 'Omat velat',
    noDebts: 'Ei maksettavaa tai saatavaa tästä turnauksesta.',
    corrections: 'Korjaukset',
    handsTitle: 'Jakohistoria',
    noHands: 'Ei vielä loppuun pelattuja jakoja.',
    showdown: 'Showdown',
    noShowdown: 'Ei showdownia',
    handDetail: 'Jako #{n}',
    loadMore: 'Vanhemmat jaot',
  },
  debts: {
    title: 'Velat',
    iOwe: 'Maksettavat',
    noticePaid: 'Ilmoita maksetuksi',
    noticeAgain: 'Muistuta uudelleen',
    noticeSent: 'Ilmoitit maksusta {time}. Velka päivittyy, kun saaja kirjaa maksun.',
    noticeDone: '{name} sai ilmoituksen maksustasi.',
    noticeReceived: '{name} ilmoitti maksaneensa {time}. Kirjaa maksu, kun näet sen.',
    owedToMe: 'Saatavat',
    noneOwe: 'Ei velkoja.',
    noneOwed: 'Kukaan ei ole sinulle velkaa.',
    total: 'Jäljellä {amount}',
    original: 'Alkuperäinen',
    paid: 'Maksettu',
    remaining: 'Jäljellä',
    source: 'Turnaus',
    correction: 'Tuloksen korjaus',
    status: { open: 'Avoin', partial: 'Osittain maksettu', paid: 'Maksettu' },
    history: 'Maksuhistoria',
    noHistory: 'Ei kirjauksia.',
    payment: 'Maksu {amount}',
    reversal: 'Peruttu −{amount}: {note}',
    reversed: 'peruttu',
    by: 'kirjasi {name}',
    record: 'Kirjaa maksu',
    recordTitle: 'Saitko maksun?',
    recordHelp: 'Kirjaa vain rahat, jotka {name} on jo maksanut sinulle. Tämä ei siirrä rahaa.',
    amount: 'Summa (€)',
    note: 'Viesti (valinnainen)',
    notePlaceholder: 'esim. MobilePay 12.1.',
    payAll: 'Koko velka {amount}',
    invalidAmount: 'Anna summa, esim. 12,50.',
    tooMuch: 'Velkaa on vain {amount}.',
    confirmRecord: 'Kirjaa {amount} maksetuksi',
    recorded: 'Maksu kirjattu.',
    reverse: 'Peru kirjaus',
    reverseTitle: 'Peru maksukirjaus',
    reverseHelp: 'Perut maksukirjauksen {amount}. Se jää historiaan, ja molemmat saavat ilmoituksen.',
    reason: 'Syy',
    reversedDone: 'Kirjaus peruttu.',
    onlyCreditor: 'Vain maksun saaja voi kirjata sen.',
    byPerson: 'Henkilöittäin',
    noOffset: 'Eri turnausten velkoja ei vähennetä toisistaan automaattisesti.',
    phone: 'puhelinnumero',
    amountWord: 'summa',
    copied: 'Kopioitu: {what}',
    copyPhone: 'Kopioi numero',
    copyAmount: 'Kopioi summa',
    noPhone: 'Ei puhelinnumeroa.',
    payMobilePay: 'Maksa MobilePaylla {amount}',
    openMobilePay: 'Avaa MobilePay',
    afterPaying: 'Kopioi numero ja summa. Avaa MobilePay ja maksa. Paina sitten Ilmoita maksetuksi. Velka päivittyy, kun saaja kirjaa maksun.',
  },
  fair: {
    badge: 'Tarkistettava jako',
    explain1:
      'Palvelin ja pelaajat lukitsevat arvontaan käyttämänsä satunnaisluvut ennen jakoa. Jaon jälkeen voit tarkistaa luvut ja laskea niistä saman pakan itse.',
    explain2:
      'Palvelin lukitsi oman lukunsa jo ennen ilmoittautumista. Kun liityit, selain loi sinulle salaisen luvun eli siemenen ja lähetti siitä vain tiivisteen. Siemen paljastetaan vasta pelin alussa, kun kaikkien tiivisteet on lukittu.',
    explain3:
      'Tarkistus kertoo, ettei pakkaa vaihdettu tai valittu jälkikäteen. Palvelin silti näkee kortit pelin aikana, eikä tarkistus estä pelaajia kertomasta korttejaan toisilleen. Jaon jälkeen voit tarkistaa kaikki kortit, myös foldatut.',
    showRecord: 'Näytä arvonnan tiedot',
    sectionTitle: 'Arvonnan tarkistus',
    legacy: 'Tämä turnaus on vanhempi kuin tarkistustoiminto. Sen jakoja ei voi tarkistaa.',
    legacyHand: 'Jakoa ei voi tarkistaa. Turnaus on vanhempi kuin tarkistustoiminto.',
    protocol: 'Protokolla',
    serverCommitment: 'Palvelimen sitoumus',
    committedAt: 'annettu {time}',
    status: 'Vaihe',
    statuses: {
      open: 'Kerätään pelaajien sitoumuksia',
      revealing: 'Odotetaan pelaajien siemeniä',
      active: 'Käynnissä',
      closed: 'Päättynyt',
    },
    yourCommitment: 'Oma sitoumuksesi',
    seedOnDevice: '(siemen on tällä laitteella)',
    seedOtherDevice: '(tällä laitteella on eri siemen)',
    seedNotHere: '(siemen on toisella laitteella)',
    lostReveal:
      'Laite lähetti siemenen {time}, ja palvelin vastaanotti sen. Turnaus ei silti käyttänyt sitä. Kerro ylläpitäjälle.',
    player: 'Pelaaja',
    commitment: 'Sitoumus',
    seed: 'Siemen',
    notYet: 'odotetaan',
    notRevealed: 'myöhästyi, jätetty pois',
    noCommitment: 'ei sitoumusta',
    seatingOk: 'Paikkojen ja ensimmäisen jakajan arvonta täsmää. Tarkistettu tällä laitteella.',
    seatingFail: 'Paikkojen arvonta ei täsmää sitoumuksiin.',
    waitingTitle: 'Peli alkaa pian',
    waitingBody: 'Odotetaan, että kaikki avaavat pelin ({n}/{total}). Sitten arvotaan paikat ja kortit.',
    waitingDeadline: 'Alkaa viimeistään {time}.',
    noSeedHere: 'Avaa sovellus laitteella, jolla liityit turnaukseen.',
    verify: 'Tarkista jako',
    verifyTitle: 'Jaon tarkistus',
    verdictOk: 'Jako täsmää. Lukituista luvuista tulee sama pakka ja samat kortit.',
    verdictPending: 'Jako on kesken. Palvelimen siemen ja kortit tulevat näkyviin jaon lopuksi.',
    verdictFail: 'Tarkistus ei onnistunut. Katso alta syy.',
    checks: {
      protocol: 'Protokolla ja jaon paikka ketjussa',
      server: 'Palvelimen siemen vastaa sitoumusta',
      players: 'Pelaajien siemenet vastaavat sitoumuksia',
      table: 'Pelaajat ja jakajan paikka noudattavat sääntöjä',
      entropy: 'Satunnaisuus laskettu uudelleen',
      deck: 'Pakka muodostettu uudelleen',
      dealt: 'Jaetut kortit vastaavat pakkaa',
      history: 'Jakohistoria vastaa pakkaa',
      observed: 'Vastaa tämän laitteen jaon aikana näkemiä tietoja',
    },
    status_ok: 'Kunnossa',
    status_fail: 'Ei täsmää',
    status_warn: 'Kunnossa, huomautus',
    status_pending: 'Odottaa jaon päättymistä',
    hand: 'Jako',
    chainPos: 'ketjun kohta {n}',
    serverSeed: 'Palvelimen siemen',
    entropy: 'Jaon satunnaisuus',
    deckDigest: 'Pakan sormenjälki',
    showDeck: 'Näytä pakan järjestys',
    hideDeck: 'Piilota pakan järjestys',
    deckOrder: 'Pakan järjestys',
    downloadEvidence: 'Lataa todisteet (JSON)',
    independent:
      'Selain tekee tarkistuksen. Voit myös ladata todisteet ja tarkistaa ne itse ohjelmalla, joka käyttää samaa julkaistua protokollaa.',
  },
  dev: {
    title: 'Kehitystila',
    actingFor: 'Pelaat pelaajan {name} puolesta',
    note: 'Vain kehitystilassa (DEV_TOOLS=1). Siirto tehdään vuorossa olevan pelaajan puolesta.',
  },
  winner: {
    title: 'Turnauksen voittaja!',
    titleTie: 'Turnauksen voittajat!',
    showResults: 'Näytä tulokset',
  },
  install: {
    title: 'Asenna HimaPokeri',
    body: 'Avaa peli omasta kuvakkeesta ilman selaimen palkkeja.',
    bodyIos: 'Lisää peli Koti-valikkoon, niin voit saada vuoroilmoituksia iPhonessa.',
    iosStep1: 'Napauta Safarin alapalkista Jaa-kuvaketta.',
    iosStep2: 'Valitse ”Lisää Koti-valikkoon” ja sitten ”Lisää”.',
    install: 'Asenna',
    notNow: 'Ei nyt',
    gotIt: 'Selvä',
  },
  chat: {
    title: 'Keskustelu',
    channels: 'Kanavat',
    global: 'Yleinen',
    empty: 'Ei vielä viestejä.',
    pickChannel: 'Valitse keskustelu.',
    tournamentChats: 'Turnausten keskustelut',
    noMessagesYet: 'Ei vielä viestejä',
    globalHint: 'Koko porukan keskustelu',
    you: 'Sinä',
    image: 'Kuva',
    openImage: 'Avaa kuva isona',
    attachImage: 'Lähetä kuva tai GIF',
    removeImage: 'Poista kuva',
    captionHint: 'Kirjoita kuvateksti viestikenttään.',
    captionPlaceholder: 'Kuvateksti (valinnainen)',
    uploading: 'Lähetetään kuvaa…',
    imageTooBig: 'Liian iso kuva. Enintään {mb} Mt.',
    playVideo: 'Toista {provider}-video',
    openInstagram: 'Avaa Instagramissa',
    yesterday: 'Eilen',
    reactionCount: '{emoji}, {n} {n|reaktio|reaktiota}',
    messageActions: 'Viestin toiminnot',
    reactWith: 'Reagoi {emoji}',
    placeholder: 'Kirjoita viesti',
    send: 'Lähetä',
    older: 'Vanhemmat viestit',
    deleted: 'Viesti poistettu',
    deletedMod: 'Ylläpito poisti viestin: {reason}',
    delete: 'Poista',
    deleteConfirm: 'Poistetaanko viesti?',
    moderateReason: 'Poiston syy',
    react: 'Reagoi',
    unread: '{n} {n|lukematon|lukematonta}',
    newMessages: 'Uudet viestit',
    record: 'Nauhoita ääniviesti',
    recording: 'Nauhoitetaan… {time}',
    stop: 'Lopeta',
    preview: 'Kuuntele ennen lähettämistä',
    discard: 'Poista nauhoitus',
    sendVoice: 'Lähetä ääniviesti',
    micDenied: 'Salli mikrofoni selaimen asetuksista ja yritä uudelleen.',
    micMissing: 'Mikrofonia ei löytynyt tai selain ei tue nauhoitusta.',
    voiceFailed: 'Lähetys ei onnistunut. Nauhoitus on tallessa. Yritä uudelleen.',
    maxLength: 'Enintään {s} sekuntia',
    play: 'Toista',
    pause: 'Tauko',
    voiceMessage: 'Ääniviesti',
    sendFailed: 'Lähetys ei onnistunut. Teksti on tallessa. Yritä uudelleen.',
    disabled: 'Tässä turnauksessa ei ole keskustelua.',
    today: 'Tänään',
  },
  stats: {
    title: 'Tilastot',
    summary: 'Yhteenveto',
    net: 'Kokonaistulos',
    tournaments: 'Turnauksia',
    tournamentsShort: 'Turn.',
    wins: 'Voittoja',
    winsShort: 'Voitot',
    itm: 'Rahoille',
    roi: 'ROI',
    avgPlace: 'Keskisijoitus',
    bestPlace: 'Paras sijoitus',
    progress: 'Tuloksen kehitys',
    chartLabel: 'Kokonaistulos euroina turnausten jälkeen, viivakaavio',
    chartHelp: 'Käyrä näyttää palkinnot miinus pelimaksut. Jokainen piste on pelaamasi turnaus.',
    legend: 'Kaavion selite',
    noData: 'Ei vielä päättyneitä turnauksia.',
    notPlayed: 'ei mukana',
    handsTitle: 'Jaot',
    handsPlayed: 'Pelatut jaot',
    handsWon: 'Voitetut jaot',
    showdowns: 'Showdownit',
    showdownWinRate: 'voitettu {pct}',
    biggestPot: 'Suurin voitettu potti',
    timeouts: 'Aika loppui',
    leaderboard: 'Kaikki pelaajat',
    compareHelp: 'Valitse kaavioon enintään {n} pelaajaa.',
    history: 'Turnaushistoria',
    tournament: 'Turnaus',
    cumulative: 'Kertynyt',
  },
  notifications: {
    newItem: '(uusi)',
    title: 'Ilmoitukset',
    empty: 'Ei ilmoituksia.',
    markAll: 'Merkitse kaikki luetuiksi',
    kinds: {
      payment_notice: '{debtorName} ilmoitti maksaneensa {amount} ({tournamentName})',
      your_turn: 'Sinun vuorosi: {tournamentName}, jako #{handNo}',
      tournament_started: 'Turnaus {tournamentName} alkoi',
      tournament_cancelled: 'Turnaus {tournamentName} peruttiin',
      terms_changed: 'Turnauksen {tournamentName} tiedot muuttuivat',
      tournament_invite: '{inviterName} kutsui sinut turnaukseen {tournamentName}',
      auto_action: 'Aikasi loppui: {tournamentName}, jako #{handNo} ({action})',
      marked_away: 'Olet poissa: {tournamentName}',
      eliminated: 'Putosit turnauksesta {tournamentName}',
      tournament_finished: 'Turnaus {tournamentName} päättyi',
      payment_recorded: 'Maksu {amount} kirjattu ({tournamentName})',
      payment_reversed: 'Maksukirjaus {amount} peruttu ({tournamentName})',
      tournament_corrected: 'Turnauksen {tournamentName} tulosta korjattiin',
      tournament_paused: 'Turnaus {tournamentName} tauolla',
      tournament_resumed: 'Turnaus {tournamentName} jatkuu',
    },
  },
  turnNotify: {
    label: 'Vuoroilmoitukset',
    both: 'Laiteilmoitus heti. Sähköposti minuutin päästä, jos et ole pelannut vuoroasi.',
    push: 'Saat laiteilmoituksen vuoron alussa.',
    email: 'Saat sähköpostin minuutin päästä, jos et ole pelannut vuoroasi.',
    emailNoDevice: 'Saat sähköpostin minuutin päästä, jos et ole pelannut vuoroasi. Laiteilmoitukset ovat pois päältä kaikilla laitteillasi.',
    noDevice: 'Laiteilmoitukset ovat pois päältä kaikilla laitteillasi. Et saa vuoroilmoituksia.',
    none: 'Vuoroilmoitukset ovat pois päältä. Näet vuorosi täällä ja Ilmoitukset-sivulla.',
    enableHere: 'Ota käyttöön tällä laitteella',
    change: 'Muuta asetuksia',
    shortTurn: 'Lyhyt vuoroaika ({minutes} min). Ei vuoroilmoituksia laitteelle tai sähköpostiin. Näet vuorosi täällä ja Ilmoitukset-sivulla.',
  },
  push: {
    blockedFootnote: '* Selain estää ilmoitukset tällä laitteella. Valinnat koskevat muita laitteitasi, joilla ilmoitukset ovat päällä.',
    thisDevice: 'Laiteilmoitukset tällä laitteella',
    onHere: 'Päällä. Saat ilmoitukset myös pelin ollessa suljettuna.',
    offHere: 'Pois päältä tällä laitteella.',
    blocked: 'Selain estää ilmoitukset. Salli ne selaimen sivustoasetuksista.',
    needsInstall: 'iPhone tai iPad: Safari → Jaa → Lisää Koti-valikkoon. Avaa peli kuvakkeesta ja palaa tähän laittamaan ilmoitukset päälle.',
    unsupported: 'Tämä selain ei tue laiteilmoituksia.',
    enable: 'Ota käyttöön',
    disable: 'Poista käytöstä',
    test: 'Lähetä testi-ilmoitus',
    testSent: 'Testi-ilmoitus lähetetty.',
    enabled: 'Laiteilmoitukset päällä.',
    denied: 'Ilmoituksia ei sallittu. Voit sallia ne selaimen asetuksista.',
    failed: 'Laiteilmoituksia ei saatu päälle.',
    deviceCount: 'Ilmoitukset päällä {n} laitteella',
    whatHappens: 'Tapahtuma',
    device: 'Laiteilmoitus',
    email: 'Sähköposti',
    inAppAlways: 'Kaikki ilmoitukset näkyvät myös Ilmoitukset-sivulla.',
  },
  profile: {
    unknownDevice: 'Tuntematon laite',
    sounds: 'Äänet',
    soundsHelp: 'Vuoron vaihtuessa äänimerkki, lopussa kellon tikitys ja voittajalle fanfaari.',
    moreLabel: 'Muut toiminnot',
    showAllSessions: 'Näytä kaikki ({n})',
    title: 'Profiili',
    avatar: 'Profiilikuva',
    avatarHelp: 'JPEG, PNG, WebP tai GIF, enintään 5 Mt. Kuvasta poistetaan sijainti- ja laitetiedot.',
    upload: 'Vaihda kuva',
    remove: 'Poista kuva',
    displayName: 'Nimi pelissä',
    displayNameHelp: 'Pyydä ylläpitäjää vaihtamaan nimi.',
    phoneTitle: 'Puhelinnumero',
    phoneHelp: 'Numero näkyy vain pelaajille, joiden kanssa sinulla on velkoja. Sen avulla voi maksaa esimerkiksi MobilePaylla.',
    phoneLabel: 'Puhelinnumero',
    phoneSaved: 'Puhelinnumero tallennettu.',
    phoneRemove: 'Poista numero',
    emailTitle: 'Sähköposti',
    changeEmail: 'Lähetä vahvistuslinkki',
    newEmailHelp: 'Avaa uuteen osoitteeseen lähetetty linkki. Sen jälkeen kirjautumislinkit tulevat sinne.',
    emailLinkSent: 'Linkki lähetetty: {email}. Avaa se 15 minuutin sisällä, niin osoite vaihtuu.',
    newEmail: 'Uusi sähköposti',
    changePassword: 'Vaihda salasana',
    displayTitle: 'Näyttö',
    amountUnit: 'Summat pöydässä',
    amountUnitHelp: 'Näytä panokset, potit ja pinot merkkeinä tai isoina blindeinä (BB). Voit vaihtaa myös pöydässä.',
    amountChips: 'Pelimerkkeinä',
    amountBb: 'Isoina blindeinä (BB)',
    notifyTitle: 'Ilmoitusasetukset',
    notifyHelp: 'Valitse laiteilmoitus, sähköposti tai molemmat.',
    prefs: {
      turn: 'Kun on vuoroni',
      reminder: 'Ennen vuoroajan loppumista',
      autoAction: 'Automaattinen check tai fold ja poissa-tila',
      tournament: 'Turnauksen alku, tauko, peruminen ja muutokset',
      results: 'Putoaminen, tulokset ja velat',
      payments: 'Velkojen maksut',
    },
    sessionsTitle: 'Kirjautuneet laitteet',
    thisDevice: 'Tämä laite',
    lastUsed: 'Viimeksi käytetty {time}',
    revoke: 'Kirjaa ulos',
    revokeOthers: 'Kirjaa ulos kaikki muut',
    mfaTitle: 'Kaksivaiheinen tunnistautuminen',
    mfaOn: 'Käytössä',
    mfaOff: 'Ei käytössä. Ota käyttöön suojataksesi tilin.',
  },
  admin: {
    title: 'Ylläpito',
    users: 'Pelaajat',
    invitations: 'Kutsut',
    tournaments: 'Turnaukset',
    system: 'Järjestelmä',
    audit: 'Tapahtumaloki',
    invite: 'Kutsu pelaaja',
    inviteSent: 'Kutsu lähetetty.',
    role: { player: 'Pelaaja', superadmin: 'Pääkäyttäjä' },
    roleLabel: 'Rooli',
    userStatus: { active: 'Käytössä', disabled: 'Poistettu käytöstä' },
    inviteStatus: { pending: 'Odottaa', accepted: 'Hyväksytty', revoked: 'Peruttu', expired: 'Vanhentunut' },
    disable: 'Poista käytöstä',
    enable: 'Ota käyttöön',
    disableConfirm: 'Suljetaanko pelaajan {name} tili? Laitteet kirjataan ulos. Keskeneräisissä peleissä peli checkaa tai foldaa hänen puolestaan.',
    rename: 'Vaihda nimi',
    templates: {
      home: { name: 'Kotiturnaus', body: '12 tuntia aikaa per vuoro.' },
      weekly: { name: 'Viikon turnaus', body: 'Täysi pöytä, isot pinot ja BB-ante. Vuorokausi per vuoro.' },
      evening: { name: 'Iltapeli', body: 'Yhden illan peli. 5 minuuttia per vuoro.' },
      live: { name: 'Livepeli', body: 'Kaikki paikalla. 30 sekuntia per vuoro.' },
      duel: { name: 'Kaksintaistelu', body: 'Kaksi pelaajaa. Voittaja vie kaiken.' },
    },
    user: {
      contact: 'Yhteystiedot',
      account: 'Tili',
      security: 'Turvallisuus',
      display: 'Näkymä ja laitteet',
      noPhone: 'Ei puhelinnumeroa',
      editPhone: 'Muuta puhelinnumeroa',
      phoneHint: 'Esim. 040 123 4567. Tyhjä kenttä poistaa numeron.',
      phoneSaved: 'Puhelinnumero tallennettu.',
      created: 'Tili luotu',
      lastSeen: 'Viimeksi paikalla',
      tournaments: 'Pelatut turnaukset',
      language: 'Kieli',
      disabledAt: 'Poistettu käytöstä',
      mfaSince: 'Käytössä {time} alkaen, varakoodeja jäljellä {n}',
      noSessions: 'Ei kirjautuneita laitteita.',
      pushDevices: 'Laiteilmoitukset',
      noPush: 'Laiteilmoitukset pois päältä.',
      pushOk: 'Toimi viimeksi {time}',
      pushNever: 'Ei vielä onnistuneita ilmoituksia',
      pushFailures: '{n} epäonnistunutta',
      on: 'Päällä',
      off: 'Pois',
    },
    revoke: 'Peru',
    resend: 'Lähetä uudelleen',
    expires: 'Vanhenee {time}',
    newTournament: 'Uusi turnaus',
    edit: 'Muokkaa',
    publish: 'Julkaise',
    publishConfirm: 'Avataanko ilmoittautuminen?',
    deleteDraft: 'Poista luonnos',
    pause: 'Tauolle',
    resume: 'Jatka',
    cancelT: 'Peru turnaus',
    cancelHelp: 'Perutusta turnauksesta ei tule palkintoja eikä velkoja.',
    correct: 'Korjaa tulos',
    correctHelp: 'Vanhat velat ja maksut säilyvät. Erotuksesta tulee erilliset velat. Kaikki pelaajat saavat ilmoituksen.',
    reason: 'Syy',
    reasonHelp: 'Syy näkyy pelaajille ja tapahtumalokissa.',
    form: {
      basics: 'Perustiedot',
      name: 'Nimi',
      description: 'Kuvaus (vapaaehtoinen)',
      money: 'Rahat',
      game: 'Peli',
      timing: 'Ajastus',
      access: 'Näkyvyys ja keskustelu',
      buyIn: 'Pelimaksu (€)',
      capacity: 'Pelaajia (2–9)',
      startingStack: 'Aloitusmerkit',
      handsPerLevel: 'Jakoja per blinditaso',
      anteMode: 'Ante',
      generate: 'Luo blindit aloitusmerkeistä',
      addLevel: 'Lisää taso',
      removeLevel: 'Poista taso {n}',
      turnHours: 'Vuoroaika',
      turnUnit: { seconds: 'sekuntia', minutes: 'minuuttia', hours: 'tuntia' },
      turnUnitLabel: 'Aikayksikkö',
      turnTooShort: 'Vuoroaika on vähintään 30 sekuntia.',
      remindersAuto: 'Muistutus {list} ennen ajan loppumista.',
      remindersNone: 'Lyhyillä vuoroilla ei lähetetä muistutuksia. Pöydän kello tikittää viimeiset 10 sekuntia.',
      liveNote: 'Alle minuutin vuoroista ei tule sähköpostia. Laiteilmoitus tulee vain, jos turnaus ei ole auki.',
      and: ' ja ',
      templates: 'Aloita pohjasta',
      templatesHelp: 'Valitse pohja ja muuta tietoja tarpeen mukaan.',
      templatePlayers: '{n} pelaajaa',
      nameHelp: 'Tyhjänä nimeksi tulee päivämäärä.',
      namePlaceholder: 'Esim. Torstain kotipeli',
      awayAfter: 'Montako vuoroa voi mennä ohi ennen poissa-tilaa',
      payout: 'Voitonjako',
      presets: { winner_takes_all: 'Kaikki voittajalle', top2: 'Kaksi parasta (65/35)', top3: 'Kolme parasta (50/30/20)', custom: 'Oma jako' },
      percent: 'Osuus (%)',
      addPlace: 'Lisää sija',
      sum: 'Yhteensä {sum} %',
      sumError: 'Osuuksien pitää olla yhteensä 100 %.',
      preview: 'Palkinnot, kun pöytä on täynnä',
      visibility: 'Kuka näkee turnauksen',
      visibilityAll: 'Kaikki pelaajat',
      visibilityInvited: 'Valitut pelaajat',
      chatEnabled: 'Turnauskeskustelu käytössä',
      voiceEnabled: 'Ääniviestit sallittu',
      deadline: 'Ilmoittautuminen päättyy (valinnainen)',
      deadlineHelp: 'Turnaus peruuntuu, jos pöytä ei täyty ajoissa.',
      create: 'Luo luonnos',
      saveChanges: 'Tallenna muutokset',
      termsWarning: 'Pelaajia on jo mukana. Jos muutat maksuja tai sääntöjä, kaikkien pitää hyväksyä muutokset.',
      lockedWarning: 'Peli on käynnissä, joten sääntöjä ei voi muuttaa. Voit laittaa pelin tauolle, perua sen tai korjata tuloksen.',
    },
    systemTitle: 'Järjestelmän tila',
    scheduler: 'Ajastin',
    healthy: 'Toimii',
    unhealthy: 'Ajastin ei vastaa. Tarkista palvelin.',
    heartbeat: 'Viimeksi vastasi {time}',
    lastOutage: 'Viime katko {from} – {to}, vuoroaikaa jatkettu {n} vuorolle',
    jobs: 'Jonot',
    dead: 'Epäonnistuneet työt',
    retrying: 'Uusi yritys odottaa',
    retry: 'Yritä uudelleen',
    overdueTurns: 'Ajan ylittäneet vuorot',
    activeTurns: 'Käynnissä olevat vuorot',
    emailFailures: 'Epäonnistuneet sähköpostit',
    emailTransport: 'Sähköpostin välitys: {t}, lähetetty 24 h aikana {n}',
    nothing: 'Ei ongelmia.',
  },
  time: {
    yesterday: 'eilen',
    later: '{d} myöhemmin',
    days: '{n} pv',
    hours: '{n} h',
    minutes: '{n} min',
    seconds: '{n} s',
    now: 'nyt',
  },
  errors: {
    network: 'Yhteys ei toimi. Tarkista netti ja yritä uudelleen.',
    internal: 'Palvelinvirhe. Toimintoa ei tehty.',
    unauthenticated: 'Kirjaudu ensin sisään.',
    invalid_credentials: 'Sähköposti tai salasana on väärin.',
    rate_limited: 'Liian monta yritystä. Odota hetki ja yritä uudelleen.',
    invalid_mfa_code: 'Väärä koodi. Tarkista tunnistussovelluksen kellonaika ja yritä uudelleen.',
    mfa_required: 'Vahvista kirjautuminen koodilla.',
    weak_password: 'Salasanassa pitää olla vähintään 10 merkkiä.',
    invitation_invalid: 'Kutsulinkki ei toimi.',
    invitation_expired: 'Kutsu vanheni. Pyydä ylläpitäjältä uusi.',
    invitation_revoked: 'Kutsu peruttiin. Pyydä ylläpitäjältä uusi.',
    invitation_accepted: 'Kutsu on jo käytetty. Kirjaudu sisään.',
    reset_invalid: 'Linkki vanheni tai on jo käytetty. Pyydä uusi.',
    invalid_email: 'Tarkista sähköpostiosoite.',
    real_money_acceptance_required: 'Hyväksy oikealla rahalla pelaaminen ja tappioiden maksaminen ennen liittymistä.',
    invalid_phone: 'Tarkista puhelinnumero, esim. 040 123 4567 tai +358 40 123 4567.',
    invalid_display_name: 'Nimeen 2–32 merkkiä: kirjaimia, numeroita, välilyöntejä tai . _ \' -',
    email_in_use: 'Sähköpostiosoite on jo käytössä.',
    display_name_in_use: 'Nimi on jo käytössä.',
    invitation_pending_for_email: 'Tähän osoitteeseen on jo lähetetty voimassa oleva kutsu.',
    invalid_password: 'Nykyinen salasana on väärin.',
    tournament_full: 'Turnaus ehti täyttyä.',
    tournament_not_open: 'Turnaukseen ei voi enää ilmoittautua.',
    terms_changed: 'Turnauksen tiedot muuttuivat. Tarkista muutokset ennen hyväksymistä.',
    turn_stale: 'Tilanne ehti muuttua. Pöytä päivitettiin.',
    deadline_passed: 'Aika loppui.',
    tournament_paused: 'Turnaus on tauolla.',
    maintenance: 'Päivitys käynnissä. Yritä uudelleen hetken päästä.',
    tournament_not_running: 'Turnaus ei ole käynnissä.',
    not_your_turn: 'Ei ole vuorosi.',
    overpayment: 'Summa on velkaa suurempi.',
    debt_already_paid: 'Velka on jo maksettu.',
    debt_changed: 'Velka muuttui. Päivitä ja yritä uudelleen.',
    only_creditor_can_record: 'Vain maksun saaja voi kirjata sen.',
    entry_already_reversed: 'Kirjaus on jo peruttu.',
    reason_required: 'Kirjoita syy.',
    file_too_large: 'Tiedosto on liian suuri.',
    invalid_image: 'Tiedostoa ei voi lukea kuvana.',
    fairness_chain_exhausted: 'Arvontaluvut loppuivat (10 000 jakoa). Turnauksen voi enää vain perua.',
    reveal_closed: 'Siementä ei voi enää lähettää.',
    seed_mismatch: 'Siemen ei vastaa sitoumusta.',
    image_too_large: 'Kuva on liian iso. Kokeile pienempää tai lyhyempää GIFiä.',
    file_required: 'Valitse lähetettävä tiedosto.',
    invalid_audio: 'Tiedostoa ei voi lukea äänenä.',
    audio_too_long: 'Ääniviesti on liian pitkä.',
    message_empty: 'Viesti on tyhjä.',
    message_too_long: 'Viesti on liian pitkä.',
    chat_disabled: 'Keskustelu ei ole käytössä.',
    voice_disabled: 'Ääniviestit eivät ole käytössä tällä kanavalla.',
    payout_sum_not_100: 'Voitonjaon pitää olla yhteensä 100 %.',
    payout_too_many_places: 'Palkintosijoja ei voi olla pelaajia enempää.',
    payout_not_descending: 'Paremmasta sijasta pitää saada vähintään yhtä paljon kuin huonommasta.',
    blinds_order: 'BB ei voi olla SB:tä pienempi.',
    blinds_decreasing: 'Blindit eivät voi laskea.',
    starting_stack_too_small: 'Aloitusmerkkejä tarvitaan vähintään 10 BB.',
    capacity_below_registered: 'Paikkoja ei voi vähentää alle mukana olevien pelaajien määrän.',
    tournament_locked: 'Turnauksen tietoja ei voi enää muuttaa.',
    deadline_in_past: 'Valitse tuleva aika.',
    last_superadmin: 'Viimeisen pääkäyttäjän tiliä ei voi sulkea.',
    cannot_disable_self: 'Et voi sulkea omaa tiliäsi.',
    placements_must_cover_all_players: 'Anna sijoitus jokaiselle pelaajalle.',
    invalid_placements: 'Tarkista sijoitukset. Tasapelissä jaettuja sijoja pitää olla yhtä monta kuin niille sijoittuvia pelaajia.',
    no_change: 'Tulos pysyisi samana.',
    validation: 'Tarkista tiedot.',
    not_found: 'Tietoa ei löydy tai et pääse siihen.',
    tournament_not_found: 'Turnausta ei löytynyt.',
    not_organizer: 'Vain turnauksen järjestäjä voi tehdä tämän.',
    invalid_invitees: 'Valitse kutsuttavat pelaajat.',
    illegal_amount_out_of_range: 'Summa on liian pieni tai suuri.',
    illegal_raise_not_allowed: 'Et voi nyt korottaa.',
    illegal_check_not_allowed: 'Et voi checkata. Panos on maksamatta.',
    illegal_fold_not_allowed: 'Voit checkata ilmaiseksi.',
    unknown: 'Toiminto epäonnistui ({code}).',
  },
} as const;

export type Messages = typeof fi;
